import { BuildVersion, IEnvironment } from './environment.interface';
import buildVersion from '@env/buildVersion';

const apiUrl = 'https://api-dmepos.portalstg2.mynexuscare.com';
const platformApiUrl = 'https://api-platform.portalstg2.mynexuscare.com';
const documentApiUrl = 'https://api-document-gateway.portalstg2.mynexuscare.com';

export const environment: IEnvironment = {
  apiUrl,
  platformApiUrl,
  documentApiUrl,
  modules: [],
  production: true,
  samples: false,
  routes: [],
  version: buildVersion as BuildVersion,
};
